import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { FormSubmitHandler } from 'Elements/Form';

import ActionsForm from './ActionsForm';
import ActionsTable from './ActionsTable';
import { initialValues, Schema } from './schema';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

export default function Actions() {
  const [params, setParams] = useState(serialize(initialValues) as Schema);

  const onSubmit: FormSubmitHandler<Schema> = values => {
    setParams(serialize(values));
  };

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <ActionsForm onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <ActionsTable params={params}></ActionsTable>
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  params.start_at = params.range.start_at;
  params.end_at = params.range.end_at;

  delete params.range;

  return params;
};
